<script>
  import { _ } from 'svelte-i18n';

  import Accessibility from "./../components/Accessibility.svelte";
</script>

<div>

  <div class="divider print:hidden"></div>

  <footer class="footer flex-col md:flex-row flex p-10 text-base-content justify-around print:hidden">
    <div>
      <img src="/assets/logo.jpg" class="w-48">

      <span class="footer-title mt-4"> Accessibility </span>
      <Accessibility></Accessibility>
    </div>

    <div>
      <span class="footer-title"> {$_('footer.project')} </span>
      <a class="link link-hover" href="https://www.onat4all.eu/"> {$_('footer.website')} </a>
      <a class="link link-hover" href="https://www.onat4all.eu/wp-content/docs/Privacy_policy_ONAT4all.pdf">Privacy policy</a>
    </div>

    <div class="w-full md:w-3/5">
      <span class="footer-title">Disclaimer</span>
      <p>Funded by the European Union. Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union or the European Education and Culture Executive Agency (EACEA). Neither the European Union nor EACEA can be held responsible for them.</p>
      <p>The answers to the questionnaire will be saved in an anonymous way.</p>
      <img src="/assets/Co-Funded by the EU_POS.png" class="w-48">
    </div>
  </footer>

</div>
